module.exports = __webpack_public_path__ + "static/media/coming.165b1dcd.jpg";